import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { OnlyRequiredFields } from "@mapmycustomers/shared";
import { AnyEntityId, EntityTypeSupportingFiles } from "@mapmycustomers/shared/types/entity";
import { RawFile } from "@mapmycustomers/shared/types/File";

export const downloadFile = createAction("@files/downloadFile")<{
  entityId?: AnyEntityId;
  entityType?: EntityTypeSupportingFiles;
  fileId: RawFile["id"];
  fileName?: string;
}>();

export const createFile = createAsyncAction(
  "@files/createFile/request",
  "@files/createFile/success",
  "@files/createFile/failure"
)<{ callback?: (file: RawFile) => void; file: Blob | File }, RawFile, unknown>();

export const updateFile = createAsyncAction(
  "@files/updateFile/request",
  "@files/updateFile/success",
  "@files/updateFile/failure"
)<{ callback?: (file: RawFile) => void; file: OnlyRequiredFields<RawFile, "id"> }, void, unknown>();

export const fetchFile = createAction("@files/fetchFile")<{
  entityId?: AnyEntityId;
  entityType?: EntityTypeSupportingFiles;
  fileId: RawFile["id"];
  onFailure?: () => void;
  onSuccess: (file: RawFile, fileBlob: Blob) => void;
}>();

// Metadata-only fetch. Returns RawFile without the blob — used by the preview
// page to decide whether the file is small enough to load into memory before
// committing to the (potentially long) blob download.
export const fetchFileMetadata = createAction("@files/fetchFileMetadata")<{
  entityId?: AnyEntityId;
  entityType?: EntityTypeSupportingFiles;
  fileId: RawFile["id"];
  onFailure?: () => void;
  onSuccess: (file: RawFile) => void;
}>();

export type Actions = ActionType<
  | typeof createFile
  | typeof downloadFile
  | typeof fetchFile
  | typeof fetchFileMetadata
  | typeof updateFile
>;
